import { ApiSet, BaseResponse, IndexApiSet, useDeleteApi, useDownloadApi, useIndexApi, usePostApi, usePutApi, useShowApi } from 'utils/network/api_hooks'
import { Form, useEffectSkipFirst } from 'utils/hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { PagingResponse } from 'entities'
import { PcrRun, PcrRunForm, PcrRunSearchForm } from 'entities/pcr_run'

type PcrRunsResponse = PagingResponse & {
    results: PcrRun[]
}

export function useFetchPcrRunsApi(searchForm: Form<PcrRunSearchForm>): IndexApiSet<PcrRunsResponse> & { execute: () => void } {
    const apiPath = 'pcr_runs/'
    const api = useIndexApi<PcrRunsResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
    })

    const execute = (): void => {
        api.execute(apiPath, { params: searchForm.object })
    }

    useEffectSkipFirst(() => {
        execute()
    }, [searchForm.object])

    return { ...api, execute: execute }
}

export function useDownloadCsvPcrRunsApi(searchForm: Form<PcrRunSearchForm>): ApiSet<BaseResponse> & { execute: () => void } {
    const apiPath = 'pcr_runs/csv/'
    const api = useDownloadApi<BaseResponse>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (): void => {
        api.execute(apiPath, 'PcrRun', searchForm.object)
    }

    return { ...api, execute: execute }
}

type PcrRunResponse = BaseResponse & {
    pcrRun?: PcrRun
}
export function usePostPcrRunApi(): ApiSet<PcrRunResponse> & { execute: (form: Form<PcrRunForm>) => void } {
    const apiSet = usePostApi<PcrRunResponse, PcrRunForm>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<PcrRunForm>) => {
        const apiPath = `pcr_runs/`
        apiSet.execute(apiPath, form)
    }

    return { ...apiSet, execute: execute }
}

export function useFetchPcrRunApi(): ApiSet<PcrRunResponse> & { execute: (id: number) => void } {
    const apiSet = useShowApi<PcrRunResponse>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (id: number) => {
        const apiPath = `pcr_runs/${id}/`
        apiSet.execute(apiPath)
    }

    return { ...apiSet, execute: execute }
}


export function usePutPcrRunApi(): ApiSet<BaseResponse> & { execute: (form: Form<PcrRunForm>) => void } {
    const apiSet = usePutApi<BaseResponse, PcrRunForm>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (form: Form<PcrRunForm>) => {
        const apiPath = `pcr_runs/${form.object.id}/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}

export function useBulkPutPcrRunsApi(): ApiSet<BaseResponse> & { execute: (form: Form<PcrRunForm[]>) => void } {
    const apiSet = usePutApi<BaseResponse, PcrRunForm[]>(
        new CraifHttpClient(),
        {
            initialResponse: {},
        },
        { formatJson: true }
    )

    const execute = (form: Form<PcrRunForm[]>) => {
        const apiPath = `pcr_runs/bulk_update/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}

export function useDeletePcrRunApi(): ApiSet<BaseResponse> & {
    execute: (id: number) => void
} {
    const api = useDeleteApi<BaseResponse>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (id: number): void => {
        const apiPath = `pcr_runs/${id}/`
        api.execute(apiPath)
    }

    return { ...api, execute: execute }
}

export function useCheckCtApi(): ApiSet<BaseResponse> & { execute: (form: Form<PcrRunForm>) => void } {
    const apiSet = usePutApi<BaseResponse, PcrRunForm>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (form: Form<PcrRunForm>) => {
        const apiPath = `pcr_runs/check_ct/`
        apiSet.execute(apiPath, form.object)
    }

    return { ...apiSet, execute: execute }
}
